import React, { Fragment } from 'react';
import styled from 'styled-components';
import { map, size } from 'lodash/fp';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonToolbar, Icon, Loader, Timeline } from 'rsuite';
import { fetchGuestAuditLogs } from '../../../redux/sagas/routines';
import {
  getMeta,
  getIsFetching
} from '../../../redux/Guest/selectors/audit-log';
import LogItem from '../../AuditLog/LogItem';

const ActionIcons = {
  view: 'eye',
  update: 'pencil',
  create: 'plus-circle',
  delete: 'trash',
  login: 'sign-in',
  logout: 'sign-out',
  login_fail: 'user-times'
};

const TimelineItem = styled(Timeline.Item)`
  padding-left: 30px !important;
  > .rs-timeline-item-dot {
    position: absolute;
    top: -2px;
    left: -8px !important;
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 26px;
    background: #fff;
    width: 26px;
    height: 26px;
  }
`;

const AuditLogList = ({ guestId, data, columns }) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  const { page = 1, total = 0 } = useSelector(getMeta);
  const dataCount = size(data);
  const handleShowMore = () => {
    dispatch(fetchGuestAuditLogs({ guestId, page: page + 1 }));
  };

  return (
    <Fragment>
      <Timeline align="left">
        {map(log => {
          const { id, objAction } = log;
          return (
            <TimelineItem
              key={`log-${id}`}
              dot={<Icon icon={ActionIcons[objAction]} />}
            >
              <LogItem key={`item-${id}`} log={log} columns={columns} />
            </TimelineItem>
          );
        }, data)}
      </Timeline>
      {isFetching && <Loader content="Loading..." style={{ marginTop: 10 }} />}
      {dataCount < total && (
        <ButtonToolbar style={{ marginTop: 20 }}>
          <Button
            appearance="primary"
            disabled={isFetching}
            onClick={handleShowMore}
          >
            Show More...
          </Button>
        </ButtonToolbar>
      )}
    </Fragment>
  );
};

const AuditLogType = PropTypes.shape({
  id: PropTypes.number,
  snapId: PropTypes.number,
  memberId: PropTypes.number,
  locationId: PropTypes.number,
  objId: PropTypes.number,
  obj2Id: PropTypes.number,
  objType: PropTypes.string,
  objAction: PropTypes.string,
  ipAddress: PropTypes.string,
  message: PropTypes.string,
  changedColumns: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({})]),
  createdAt: PropTypes.string,
  member: PropTypes.shape({
    id: PropTypes.number,
    firstname: PropTypes.string,
    lastname: PropTypes.string
  })
});

AuditLogList.propTypes = {
  guestId: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(AuditLogType).isRequired,
  columns: PropTypes.shape({}).isRequired
};

AuditLogList.defaultProps = {};

export default AuditLogList;
